import FootballSerializer from "../../FootballSerializer";

export const ContextSerializer = {
    serialize(gameContext) {
        const fieldPositionFormatted =
            FootballSerializer._formatGameContextFieldPosition(gameContext);

        //TODO: See how to resolve scrimmage line.
        const scrimmageLinePositionFormatted =
            FootballSerializer._formatGameContextFieldPosition(gameContext);
        const teamPossession = gameContext.isHomePossession() ? "H" : "V";

        const values = [
            fieldPositionFormatted,
            scrimmageLinePositionFormatted,
            teamPossession,
            gameContext.down,
            //TODO: See how to set isTouchdown in the Touchdown rule. Problem is it will depend on the play too.
            Boolean(gameContext.isTouchdown).toString()
        ];

        return values.join(",");
    }
};
